import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import i18next from "i18next";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import ReportPlaceholder from "@mnjsplatform/components/lib/common/Reports/ReportPlaceholder";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";

class Reports extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedReport: null
        };
    }

    componentDidMount() {
        this.init();
    }

    init = async() => {
        try {
            await this.props.dispatch(this.props.reportsList.execute({}, {withParams: false}));
        }
        catch (e) {
            console.log(e);
        }
    };

    onPopupClose = () => {
        this.setState({selectedReport: null});
    };

    showReport = (r) => {
        this.setState({selectedReport: r});
    };

    renderReportParams = (h) => {
        return (
            <>
                {h.fs.map((fi) => {
                    const fn = fi.Name;
                    return (
                        <React.Fragment key={fn}>
                            <div className="row">
                                <div className="col-md-3 field-title">
                                    {h.lbl(fn)}
                                </div>
                                <div className="col-md-9">
                                    {h.ed(fn)}
                                </div>
                            </div>
                            <hr/>
                        </React.Fragment>
                    );
                })}
            </>
        );
    };

    renderPopupButtons(build) {
        return (
            <div className="modal-footer text-right">
                <button type="button" className="btn btn-regular -goahead"
                        onClick={async(e) => {
                            e.preventDefault();
                            await build();
                        }}
                >
                    {i18next.t("BuildReport")}
                </button>
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={this.onPopupClose}
                >
                    {i18next.t('Close')}
                </button>
            </div>
        );
    }

    renderReportPopup = () => {
        const r = this.state.selectedReport;
        if (!r) {
            return null;
        }

        const reportId = r["ReportScId"];
        return (
            <ReportPlaceholder reportKey={reportId} reportId={reportId} showLabelOnLoading={false}>
                {(reportParamsItem, build) => {
                    return (
                        <PopupWrapper onClose={this.onPopupClose}
                                      popupVisible={true}
                                      title={r["ReportScName"]}
                                      renderButtons={() => this.renderPopupButtons(build)}
                        >
                            <ComplexParam dataItem={reportParamsItem}
                                          readOnly={false}
                                          showSearchBar={false}
                                          showApplyButton={false}
                                          autoApplyParams={false}
                                          rootPath="/"
                                          renderParams={this.renderReportParams}
                            />
                        </PopupWrapper>
                    );
                }}
            </ReportPlaceholder>
        );
    };

    renderReportRow = (r) => {
        return (
            <div key={r["ReportScId"]}>
                <button className="btn mn-btn-link" onClick={() => this.showReport(r)}>
                    {r["ReportScName"]}
                </button>
            </div>
        );
    };

    renderReports = () => {
        const dataTable = this.props.reportsList.dataTable();

        if (dataTable.length === 0) {
            return i18next.t("NoAvailableReports");
        }

        return (
            <>
                {dataTable.map(r => this.renderReportRow(r))}
            </>
        );
    };

    render() {
        if (!this.props.reportsList.isInitialized) {
            return (<div>{i18next.t("LoadingLabel")}</div>);
        }

        return (
            <>
                <div className="row" style={{marginTop: "10px", marginBottom: "10px"}}>
                    <div className="col-md-12">
                        <h1 className="page-title">
                            {i18next.t("ReportsTitle")}
                        </h1>
                    </div>
                </div>

                {this.renderReports()}
                {this.renderReportPopup()}
            </>
        );
    }
}

Reports.propTypes = {
    dispatch: PropTypes.func,
    reportsList: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {
        reportsList: state.reportsState.reportsList
    };
}

export default connect(mapStateToProps)(Reports);